import React from 'react';

const LoadingSkeleton = () => {
  return (
    <div className="flex flex-col gap-6 py-6 animate-pulse">
      {[0, 1, 2, 3].map((i) => (
        <div key={i} className="flex w-full flex-wrap items-start gap-x-8 gap-y-4">
          {/* Label column */}
          <div className="flex flex-1 flex-col items-start min-w-[240px] max-w-[280px]">
            <div className="h-4 bg-gray-200 rounded w-3/4" />
          </div>
          {/* Value column */}
          <div className="flex flex-1 flex-col min-w-[400px] max-w-[512px] gap-2">
            <div className="h-4 bg-gray-200 rounded w-2/3" />
            <div className="h-4 bg-gray-200 rounded w-1/2" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default LoadingSkeleton;
